<template>
    <div class="container" v-html="endUserAgreement"></div>
</template>

<script>
import { i18nMixin } from '../../modules/shared/mixins/i18n.mixin';

export default {
    name: 'end-user-agreement',

    props: {},

    data () {
        return {
            endUserAgreement: this.i18n('Message.EndUserAgreement')
        };
    },

    mixins: [i18nMixin],

    methods: {},

    mounted () {
    }
};
</script>

<style lang="scss" scoped>
    .container {
        overflow-y: auto !important;
        margin: 0;
        padding: 4rem;
        width: 100%;

        p {
            font-size: 14px;
        }

        li {
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/end-user-agreement/end-user-agreement.vue